import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LegalDocument } from '../../models/legal-document.model';
import { LegalDocumentsService } from '../../services/legal-documents.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css'
})
export class PrivacyPolicyComponent {
  formatUpdatedAt(value: unknown): Date | null {
    const candidate = value as { toDate?: () => Date } | Date | null | undefined;
    if (candidate instanceof Date) {
      return candidate;
    }

    if (candidate && typeof candidate === "object" && typeof candidate.toDate === "function") {
      return candidate.toDate();
    }

    return null;
  }

  readonly document$: Observable<LegalDocument> = this.legalDocumentsService.getLegalDocument('privacy-policy');

  constructor(private readonly legalDocumentsService: LegalDocumentsService) {}
}
